import { AutocompleteValue } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { GroupMembersDropDown } from 'src/legacy/components/GroupMembers/GroupMembersDropDown';
import { PopoverCloseReason } from 'src/legacy/components/Select/SelectDropdown';
import { SelectOption } from 'src/legacy/components/Select/types';

interface UseMemberDropdownHookOptions {
  id: string;
  memberIDs: string[];
  selectedChannelMembersWithOneChannel?: string[] | undefined;
  onMemberUpdates?: (memberIds: string[]) => void;
  companyId?: string;
}

export const useMemberDropDownHook = (
  options: UseMemberDropdownHookOptions,
) => {
  const { t } = useTranslation();
  const [groupMemberDropdownAnchor, setGroupMemberDropdownAnchor] =
    React.useState<null | HTMLElement>(null);
  const [showGroupMembersDropDown, setShowGroupMembersDropDown] =
    React.useState<boolean>(false);
  const [selectedAssignees, setSelectedAssignees] = React.useState<
    AutocompleteValue<SelectOption, true, undefined, undefined>
  >([]);

  const handleCloseAssigneeDropDown = (
    _: unknown,
    reason: PopoverCloseReason,
  ) => {
    if (reason === 'toggleInput') {
      return;
    }
    const newMemberIds = selectedAssignees.map((member) => member.id);
    const originalMembersIdString = options.memberIDs.sort().join('');
    const newMemberIdsString = newMemberIds.sort().join('');

    if (
      options.onMemberUpdates &&
      originalMembersIdString !== newMemberIdsString
    ) {
      // update members only if user has changed the assignee list
      options.onMemberUpdates(newMemberIds);
    }

    setShowGroupMembersDropDown(false);
  };

  const handleAssigneeChange = (
    currentAssignees: AutocompleteValue<
      SelectOption,
      true,
      undefined,
      undefined
    >,
  ) => {
    setSelectedAssignees(currentAssignees);
  };

  const RenderGroupMembersDropdown = () =>
    showGroupMembersDropDown && (
      <GroupMembersDropDown<true>
        companyId={options.companyId}
        memberIDs={options.memberIDs}
        assigneeDropDownId={options.id}
        open={showGroupMembersDropDown}
        anchorEl={groupMemberDropdownAnchor}
        onClose={handleCloseAssigneeDropDown}
        placeholder={t(($) => $.actions.type_to_find_clients)}
        isMultiple
        onChange={handleAssigneeChange}
        disableCloseOnSelect
        disabledIDsForSelection={
          options.selectedChannelMembersWithOneChannel || []
        }
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'bottom',
        }}
        transformOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
      />
    );

  return {
    groupMemberDropdownAnchor,
    setGroupMemberDropdownAnchor,
    showGroupMembersDropDown,
    setShowGroupMembersDropDown,
    RenderGroupMembersDropdown,
  };
};
